// TODO: cleanup with skip_process_confirmation_modal ff
//
// sessionStorage breadcrumb so a cohort-process run started by clicking
// Process (`useInlineProcessCohort`) or by RA itself (`ActiveChatContext`'s
// `onCohortProcessingStarted`) survives a page refresh/remount. Without it a
// refresh mid-request wipes the in-memory `isExecutionPending` flag, and a
// fetch landing in the backend's pre-commit window reads a stale `DRAFT`
// status with nothing left to restart polling.

const PENDING_KEY_PREFIX = 'cohort-process-pending:';

// A marker older than this is treated as expired — a stuck breadcrumb
// must not pin the button in "Queuing…" forever.
// Wide enough to cover the backend commit window.
export const COHORT_PROCESS_PENDING_TTL_MS = 20_000;

const getPendingKey = (cohortId: string) => `${PENDING_KEY_PREFIX}${cohortId}`;

export const readCohortProcessPendingTimestamp = (cohortId: string): number | null => {
  try {
    const raw = sessionStorage.getItem(getPendingKey(cohortId));
    return raw ? Number(raw) : null;
  } catch {
    return null;
  }
};

export const writeCohortProcessPendingMarker = (cohortId: string): void => {
  try {
    sessionStorage.setItem(getPendingKey(cohortId), String(Date.now()));
  } catch {
    /* ignore */
  }
};

export const clearCohortProcessPendingMarker = (cohortId: string): void => {
  try {
    sessionStorage.removeItem(getPendingKey(cohortId));
  } catch {
    /* ignore */
  }
};
